export function getSelectOptionsFromObjectArray<T extends Record<string, any>>(
  data: Array<T>,
  labelKey: keyof T,
  valueKey: keyof T,
  tagKey: keyof T | null,
  t = (key: string) => key
): SelectOption[] {
  return data.map((item) => ({
    label: t(item[labelKey] as string),
    value: item[valueKey],
    tag: tagKey ? { label: t(item[tagKey] as string) } : undefined,
  }));
}
